import participantsFileTabTemplate from './interact-participants-tab.tpl.html';
import './interact-participants.less';

/**
 * Creates a tab object for MultiFileLayout that contains Interact participants
 * @param {assessmentResultProcess} process
 * @returns {{template: *, readonly usersList: *, readonly hidden: *, readonly icon: string, id: string, label: string}}
 */
export function createInteractParticipantsTab(process) {
  return {
    id: 'interactparticipants',
    get icon() {
      return `status-done ${process.liveInterview.usersList.length > 1 ? 'participants-active' : ''}`;
    },
    label: 'Interact',
    template: participantsFileTabTemplate,
    get hidden() {
      return !process.liveInterviewActive;
    },
    get usersList() {
      return process.liveInterviewActive && process.liveInterview.usersList;
    },
  };
}
